import request from "@/utils/request";

// 发送消息(内部调用)
export function baseNoticeSend(data) {
  return request({
    url: `/base/base/notice/send`,
    method: "post",
    data: data,
  });
}

// 一键已读消息
export function baseReadNotice(data) {
  return request({
    url: `/base/base/notice/one/click/read/notice`,
    method: "post",
    // data: data,
  });
}

// 读消息
export function baseNoticeReadNotice(data) {
  return request({
    url: `/base/base/notice/read/notice`,
    method: "post",
    data: data,
  });
}

// 获取我的消息列表
export function baseNoticeByPage(data) {
  return request({
    url: `/base/base/notice/get/my/notice/list/by/page`,
    method: "post",
    data: data,
  });
}

// 获取我的未读消息个数
export function baseReadNoticeCount(data) {
  return request({
    url: `/base/base/notice/get/my/no/read/notice/count`,
    method: "post",
    data: data,
  });
}

// 同意加入教研组
export function teachingResearchClassroomPage(userId, data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/consent`,// ?userId=${userId}
    method: "post",
    params: data,
  });
}

// 不同意加入教研组
export function teachingResearchClassroomDenyUserApply(userId, data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/noConsent`,// ?userId=${userId}
    method: "post",
    params: data,
  });
}


// 后台查询教研室表
export function teachingResearchPage(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/page`,
    method: "post",
    data: data,
  });
}

// 我的教研组分页查询
export function teachingResearchMyJyClassRoom(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/myJyClassRoom`,
    method: "post",
    data: data,
  });
}

// 新增教研室表
export function teachingResearchAddClassRoom(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/addClassRoom`,
    method: "post",
    data: data,
  });
}

// 通过id查询教研室表
export function teachingResearchGetInfoById(id) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/getInfoById?id=${id}`,
    method: "get",
  });
}

// 修改教研室
export function teachingResearchUpdateClassRoom(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/updateClassRoom`,
    method: "post",
    data: data,
  });
}

// 删除教研室
export function teachingResearchDeleteByIds(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/deleteByIds`,
    method: "post",
    data: data,
  });
}

// 教师管理-教师列表(t)
export function getBaseTeacherList(data) {
  return request({
    url: `/base/user/v1/teacher/list`,
    method: "post",
    data: data,
  });
}

// 退出教研组
export function teachingResearchExitClassRoom(id) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/exitClassRoom?id=${id}`,
    method: "post",
  });
}

// 加入教研组（通过邀请链接）
export function teachingJoinClassRoomByLink(value) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/joinClassRoomByLink`,
    method: "post",
    data: {
      value: value,
    },
  });
}

// 查询教研室用户列表
export function getSelectUserListByClassRoomId(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/selectUserListByClassRoomId`,
    method: "post",
    data: data,
  });
}

// 添加教研室用户
export function teachingResearchAddClassRoomUser(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/addClassRoomUser`,
    method: "post",
    data: data,
  });
}

// 查询申请用户列表
export function teachingResearchSeleceApplyUser(id, queryName) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/seleceApplyUser?id=${id}&queryName=${queryName}`,
    method: "get",
  });
}

// 通过申请
export function teachingResearchPassUserApply(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/passUserApply`,
    method: "post",
    data: data,
  });
}

// 忽略申请
export function teachingResearchDenyUserApply(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/denyUserApply`,
    method: "post",
    data: data,
  });
}

// 删除教研室用户
export function teachingResearchDeleteClassRoomUser(data) {
  return request({
    url: `/app/zhkt/teaching/research/classroom/deleteClassRoomUser`,
    method: "post",
    data: data,
  });
}

// 分页查询评课主表
export function evaluateCoursePage(data) {
  return request({
    url: `/app/zhkt/evaluate/course/page`,
    method: "post",
    data: data,
  });
}

// 新增评课主表
export function evaluateCourseSave(data) {
  return request({
    url: `/app/zhkt/evaluate/course/save`,
    method: "post",
    data: data,
  });
}

// 删除评课主表
export function evaluateCourseDeleteById(data) {
  return request({
    url: `/app/zhkt/evaluate/course/deleteById`,
    method: "post",
    data: data,
  });
}

// 判断使用量
export function evaluateCourseIdUseCont(data) {
  return request({
    url: `/app/zhkt/evaluate/course/idUseCont`,
    method: "post",
    data: data,
  });
}

// 通过id查询评课主表
export function evaluateCourseGetInfoById(id) {
  return request({
    url: `/app/zhkt/evaluate/course/getInfoById?id=${id}`,
    method: "get",
  });
}

// 修改评课主表
export function evaluateCourseUpdate(data) {
  return request({
    url: `/app/zhkt/evaluate/course/update`,
    method: "post",
    data: data,
  });
}

// 后台查询评课课例
export function sgktteachingresearchevaluationPage(data) {
  return request({
    // url: `/app/zhkt/teachingresearchevaluation/v1/page`,
    url: `/app/zhkt/teachingresearchevaluation/v1/page`,
    method: "post",
    data: data,
  });
}

// 后台查询直播列表
export function sgktteachingresearchLivePage(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/page`,
    method: "post",
    data: data,
  });
}

// 后台查询互动教研
export function sgktteachingresearchInteractionPage(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/page`,
    method: "post",
    data: data,
  });
}

// 新增评课课例表
export function sgktteachingresearchevaluationSave(data) {
  return request({
    // url: `/app/zhkt/teachingresearchevaluation/v1/save`,
    url: `/app/zhkt/teachingresearchevaluation/v1/save`,
    method: "post",
    data: data,
  });
}

// 新增教研直播
export function sgktteachingresearchLiveSave(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/save`,
    method: "post",
    data: data,
  });
}

// 新增互动教研表
export function sgktteachingresearchInteractionSave(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/save`,
    method: "post",
    data: data,
  });
}

// 新增互动教研表
export function sgktteachingresearchInteractionSaveNewDto(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/saveNewDto`,
    method: "post",
    data: data,
  });
}

// 查询评课设置列表
export function evaluateCourseGetList() {
  return request({
    url: `/app/zhkt/evaluate/course/getList`,
    method: "get",
  });
}

// 教研室下拉列表
export function teachingClassroomGetList() {
  return request({
    url: `/app/zhkt/teaching/research/classroom/getList`,
    method: "get",
  });
}

// 通过id查询评课课例表
export function sgktteachingresearchevaluationGetInfoById(evCourseId) {
  return request({
    url: `/app/zhkt/teachingresearchevaluation/v1/getInfoById?evCourseId=${evCourseId}`,
    method: "get",
  });
}

// 修改评课课例表
export function sgktteachingresearchevaluationUpdate(data) {
  return request({
    url: `/app/zhkt/teachingresearchevaluation/v1/update`,
    method: "post",
    data: data,
  });
}

// 删除评课课例表
export function sgktteachingresearchevaluationDeleteById(data) {
  return request({
    url: `/app/zhkt/teachingresearchevaluation/v1/deleteById`,
    method: "post",
    data: data,
  });
}

// 通过id查询教研直播表
export function sgktteachingresearchGetInfoById(id) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/getInfoById?id=${id}`,
    method: "get",
  });
}

// 修改教研直播
export function sgktteachingresearcheLiveUpdate(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/update`,
    method: "post",
    data: data,
  });
}

// 删除教研直播表
export function sgktteachingresearchLiveDeleteByIds(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/deleteByIds`,
    method: "post",
    data: data,
  });
}

// 通过id查询互动教研表
export function sgktteachingresearchInteraction(id) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/getInfoById?id=${id}`,
    method: "get",
  });
}

// 通过id查询互动教研表
export function sgktteachingresearchGetNewInfoById(id) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/getNewInfoById?id=${id}`,
    method: "get",
  });
}

// 修改互动教研表
export function sgktteachingresearcheUpdate(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/update`,
    method: "post",
    data: data,
  });
}

// 删除互动教研表
export function sgktteachingresearchDeleteById(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/deleteById`,
    method: "post",
    data: data,
  });
}

// 根据时间选择课节信息
export function sgktSelectCourseSectionList(data) {
  return request({
    url: `/app/zhkt/deliver/class/v1/selectCourseSectionList`,
    method: "post",
    data: data,
  });
}

// 我的教研直播列表
export function teachingResearchList(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/myPage`,
    method: "post",
    data: data,
  });
}

// 我的教研课例评课列表
export function sgktteachin(data) {
  return request({
    url: `/app/zhkt/teachingresearchevaluation/v1/myPage`,
    method: "post",
    data: data,
  });
}

// 我的教研互动列表
export function teachingInteraction(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/myPage`,
    method: "post",
    data: data,
  });
}

// 获取课例评课fileId
export function getFileId(evCourseId) {
  return request({
    url: `/app/zhkt/teachingresearchevaluation/v1/getFileId?evCourseId=${evCourseId}`,
    method: "post",
  });
}

// 获取视频下载地址
export function getDownloadUrl(id) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/hero/getDownloadUrl?id=${id}`,
    method: "get",
  });
}

// 获取学校名称
export function getSchoolName() {
  return request({
    url: `/app/zhkt/teaching/research/classroom/getSchoolName`,
    method: "get",
  });
}

// 创建课程
export function courseCreate(data) {
  return request({
    url: `/app/zhkt/course/create`,
    method: "post",
    data: data,
  });
}

// 创建课程
export function courseListByPage(data) {
  return request({
    url: `/app/zhkt/course/list/by/page`,
    method: "post",
    data: data,
  });
}

// 批量发布课程
export function courseBatchPublish(data) {
  return request({
    url: `/app/zhkt/course/batch/publish`,
    method: "post",
    data: data,
  });
}

// 批量停止课程
export function courseBatchStop(data) {
  return request({
    url: `/app/zhkt/course/batch/stop`,
    method: "post",
    data: data,
  });
}

// 获取视频下载地址
export function courseBatchRemove(data) {
  return request({
    url: `/app/zhkt/course/batch/remove`,
    method: "post",
    data: data,
  });
}

// 获得课程详情
export function courseDetail(id) {
  return request({
    url: `/app/zhkt/course/detail?id=${id}`,
    method: "get",
  });
}

// 更新课程
export function courseUpdate(data) {
  return request({
    url: `/app/zhkt/course/update`,
    method: "post",
    data: data,
  });
}

// 操作课程自定义设置
export function courseCustomSetting(data) {
  return request({
    url: `/app/zhkt/course/custom/setting/operate/course/custom/setting`,
    method: "post",
    data: data,
  });
}

// 查询课程下章节
export function courseChapterListByCourse(data) {
  return request({
    url: `/app/zhkt/course/chapter/get/list/by/course`,
    method: "post",
    data: data,
  });
}

// 下载课程章节导入模板
export function courseDownloadTemplate() {
  return request({
    url: `/app/zhkt/course/chapter/download/import/template`,
    method: "get",
    responseType: "blob",
  });
}

// 导出课程下章节
export function courseChapteExport(data) {
  return request({
    url: `/app/zhkt/course/chapter/export`,
    method: "post",
    data: data,
    responseType: "blob",
  });
}

// 导入课程章节
export function courseChapteImport(data, courseId) {
  return request({
    url: `/app/zhkt/course/chapter/import?courseId=${courseId}`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  });
}

// 创建课程章节
export function courseChapterCreate(data) {
  return request({
    url: `/app/zhkt/course/chapter/create`,
    method: "post",
    data: data,
  });
}

// 更新课程章节
export function courseChapterUpdate(data) {
  return request({
    url: `/app/zhkt/course/chapter/update`,
    method: "post",
    data: data,
  });
}

// 删除课程章节
export function courseChapterRemove(id) {
  return request({
    url: `/app/zhkt/course/chapter/remove?id=${id}`,
    method: "delete",
  });
}

// 删除课程下章节
export function courseChapterRemoveCourse(courseId) {
  return request({
    url: `/app/zhkt/course/chapter/remove/by/course?courseId=${courseId}`,
    method: "delete",
  });
}

// 移动课程章节
export function courseChapterMove(data) {
  return request({
    url: `/app/zhkt/course/chapter/move`,
    method: "post",
    data: data,
  });
}

// 置顶 课例
export function KLsetTop(id, type) {
  return request({
    url: `/app/zhkt/teachingresearchevaluation/v1/setTop?id=${id}&type=${type}`,
    method: "post",
  });
}
// 置顶 直播
export function LIVEsetTop(id, type) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/setTop?id=${id}&type=${type}`,
    method: "post",
  });
}
// 置顶 互动
export function HDsetTop(id, type) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/setTop?id=${id}&type=${type}`,
    method: "post",
  });
}

// 创建课程资源
export function courseResourceCreate(data) {
  return request({
    url: `/app/zhkt/course/resource/create`,
    method: "post",
    data: data,
  });
}

// 查询课程章节下资源
export function courseResourceList(data) {
  return request({
    url: `/app/zhkt/course/resource/get/list/by/course/chapter`,
    method: "post",
    data: data,
  });
}

// 查询课程章节下资源
export function courseResourceUpdate(data) {
  return request({
    url: `/app/zhkt/course/resource/update`,
    method: "post",
    data: data,
  });
}

// 移动课程资源
export function courseResourceMove(data) {
  return request({
    url: `/app/zhkt/course/resource/move`,
    method: "post",
    data: data,
  });
}

// 删除课程章节
export function courseResourceRemove(id) {
  return request({
    url: `/app/zhkt/course/resource/remove?id=${id}`,
    method: "delete",
  });
}

// 获得试卷详情
export function courseTestDetail(id) {
  return request({
    url: `/app/zhkt/test/paper/detail?id=${id}`,
    method: "get",
  });
}

// 创建课程测试题目
export function courseTestQuestion(data) {
  return request({
    url: `/app/zhkt/test/paper/create/course/test/question`,
    method: "post",
    data: data,
  });
}

// 删除课程测试题目
export function courseRemoveQuestion(data) {
  return request({
    url: `/app/zhkt/test/paper/remove/course/test/question`,
    method: "post",
    data: data,
  });
}

// 移动课程测试题目
export function courseMoveQuestion(data) {
  return request({
    url: `/app/zhkt/test/paper/move/course/test/question`,
    method: "post",
    data: data,
  });
}

// 修改课程测试题目
export function courseUpdateQuestion(data) {
  return request({
    url: `/app/zhkt/test/paper/update/course/test/question`,
    method: "post",
    data: data,
  });
}
// 下载txt基础文件信息
export function downloadTxt(id) {
  return request({
    url: `/ai/voice/v1/downloadTxt?id=${id}`,
    method: "get",
  });
}

// 将知识文档上传到ai服务
export function fileToAi(pdfPath) {
  return request({
    url: `/ai/deekseek/v1/fileToAi?pdfPath=${pdfPath}`,
    method: "post",
  });
}

// 根据文档生成多个图谱数据(list中传入对应图谱id(1.知识点,2.能力图谱,3问题图谱))
export function generateKnowledgeMaps(data) {
  return request({
    url: `/ai/deekseek/v1/generateKnowledgeMaps`,
    method: "post",
    data: data,
  });
}

// 获取课程知识点树图
export function knowledgePointsTree(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/knowledge/points/tree`,
    method: "get",
    params: data,
  });
}

// 保存知识点
export function knowledgePointsSave(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/knowledge/points/save`,
    method: "post",
    data: data,
  });
}

// 删除知识点
export function knowledgePointsDelete(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/knowledge/points/delete`,
    method: "get",
    params: data,
  });
}

// 获取课程能力图谱
export function knowledgeCapabilityMap(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/capability/map`,
    method: "get",
    params: data,
  });
}

// 批量移除课程自定义设置
export function courseSettingBatchRemove(data) {
  return request({
    url: `/app/zhkt/course/custom/setting/batch/remove`,
    method: "post",
    data: data,
  });
}

// 获取课程能力图谱
export function knowledgePoints(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/resource/knowledge/points`,
    method: "get",
    params: data,
  });
}

// 课程资源关联知识点
export function knowledgeAssociationPoints(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/resource/association/knowledge/points`,
    method: "post",
    data: data,
  });
}

// 是否章节覆盖
export function chapterCover(id, cover) {
  return request({
    url: `/app/zhkt/course/chapter/cover?id=${id}&cover=${cover}`,
    method: "post",
  });
}

// 下载直播教研导入模板
export function teachingDownloadImportTemplate(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/download/import/template`,
    method: "get",
    params: data,
    responseType: "blob",
  });
}

// 导入教研直播
export function teachingImportTemplate(data, serverIp) {
  return request({
    url: `/app/zhkt/teaching/research/live/import?baseApi=${window.g.BASE_API}&privatization=${window.g.privatization === false ? 0 : 1}&serverIp=${serverIp}`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  });
}

// 保存课程能力
export function knowledgeCapabilitySave(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/capability/save`,
    method: "post",
    data: data,
  });
}

// 获取能力关联知识点
export function knowledgeKnowledgePoints(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/capability/knowledge/points`,
    method: "get",
    params: data,
  });
}

// 删除课程能力
export function knowledgeCapabilityDelete(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/capability/delete`,
    method: "post",
    params: data,
  });
}

// 能力关联知识点
export function knowledgeAssociationKnowledgePoints(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/capability/association/knowledge/points`,
    method: "post",
    data: data,
  });
}

// 下载课程章节导入模板
export function knowledgeDownloadTemplate() {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/import/template`,
    method: "get",
    responseType: "blob",
  });
}

// 获取知识点资源推荐
export function knowledgeResourceRecommend(data) {
  return request({
    url: `/app/zhkt/knowledge/graph/v1/resource/recommend`,
    method: "get",
    params: data,
  });
}
// 导出调出教研活动数据 type：0课例评课 1教研直播 2远程互动 
export function teachingDataExport(data,language) {
  return request({
    url: `/app/zhkt/stat/teaching/data/export?type=${data.type}&startTime=${data.startTime}&endTime=${data.endTime}`,
    method: "post",
    responseType: "blob",
    headers: { "Language": language },
  });
}

// 前台-直播详情-获取直播签到人员列表
export function liveSignInList(data) {
  return request({
    url: `/app/zhkt/live/signIn/v1/get/signIn/list`,
    method: "post",
    data: data,
  });
}

// 前台-直播详情-直播签到
export function liveSignIn(data) {
  return request({
    url: `/app/zhkt/live/signIn/v1/signIn`,
    method: "post",
    data: data,
  });
}

// 前台-直播详情-获取直播签到倒计时
export function getLiveSignInCountdown(liveId) {
  return request({
    url: `/app/zhkt/live/v1/get/signIn/countdown?liveId=${liveId}`,
    method: "get",
  });
}

// 直播签到信息导出
export function getLiveSignInExport(liveId) {
  return request({
    url: `/app/zhkt/live/signIn/v1/export?liveId=${liveId}`,
    method: "get",
    responseType: 'blob',
  });
}

// 判断用户在当前直播是否已签到
export function getLiveCheckSignIn(liveId) {
  return request({
    url: `/app/zhkt/live/signIn/v1/check/signIn?liveId=${liveId}`,
    method: "get",
  });
}
